import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="min-h-screen flex items-center justify-center bg-airy-main p-4">
          <div className="text-center max-w-md">
            <h2 className="text-orange-gold text-2xl font-black mb-4">
              אירעה שגיאה
            </h2>
            <p className="text-airy-primary text-base mb-6">
              מצטערים, משהו השתבש. אנא רענן את הדף או נסה שוב מאוחר יותר.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-orange-gold text-airy-primary px-6 py-3 rounded-pill font-normal hover:opacity-90 transition-opacity"
            >
              רענן דף
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

